export const getInitialState = () => ({
    fromCountry: [],
    toCountry: [],
    fromLocationName: [],
    toLocationName: [],
    adults: 0,
    children: []
});
